'use strict';

/**
 * @deprecated
 */
module.exports = {
	INDIVIDUAL: 'individual',
	FAMILY: 'family'
};
